<script lang="ts">
  import clsx from "clsx";
  import { ChevronDown } from "lucide-svelte";

  import Dropdown from "./Dropdown.svelte";
  import DropdownItemGroup from "./DropdownItemGroup.svelte";

  export let label: string = "";
  export let value: string;
  export let buttonClass: string = "";
  export let hideTextOnMobile: boolean = false;
  export let size: "normal" | "wide" = "normal";
  export let align: "left" | "right" | "full" = "left";
</script>

<Dropdown {align}>
  <button class={size === "wide" ? "w-full" : "w-fit"} slot="button">
    <div class="whitespace-nowrap">
      <slot name="button">
        <span
          class={clsx(
            "flex items-center gap-1 text-sm rounded-lg hover:bg-white/10 text-zinc-400 p-2 cursor-pointer",
            buttonClass,
          )}
        >
          <slot name="icon" />
          {#if label}
            <span class={clsx(hideTextOnMobile && "hidden sm:block")}>
              {label}:
            </span>
          {/if}
          <span
            class={clsx("text-white", hideTextOnMobile && "hidden sm:block")}
          >
            {value}
          </span>
          <ChevronDown size={16} />
        </span>
      </slot>
    </div>
  </button>
  <DropdownItemGroup size={size === "wide" ? "fit-content" : "standard"}>
    <slot />
  </DropdownItemGroup>
</Dropdown>
